<template>
  <div class="jwx-pro-forecast__message-banner jwx-pro-forecast__out-of-season-banner">
    <p class="jwx-pro-forecast__message-title">This forecast is currently out of season.</p>
    <p class="jwx-pro-forecast__message-body">It will start again in the spring.</p>
  </div>
</template>